<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    ref="table"
  >
    <template #DETAILS="{ visible, params }">
      <!-- <Details
        v-if="visible"
        :billId="params.row.id"
        :check_bill_number="params.row.bill_number"
        :codStatus="params.row.types"
        :total_amount="params.row.total_amount"
      ></Details> -->
      <Details v-if="visible" :row="params"></Details>
    </template>
  </cTable>
</template>

<script>
import {
  getB2bBill,
  getB2bBillUSer,
  addB2bBill,
  updateB2bBill,
  ConfirmB2bBill,
  getDetails,
  b2bReStatistics,
  b2bWriteOff,
  getConfig,
  delDouBill,
  getB2bBillDetails,
  getB2bContractHeader,
  againBillAmount,
  postConfirm,
	append,
	removeDetail1,
	recalculate,
	getWaitWriteOff,
	getWriteOffRecord,
	cancelConfirm
} from "@/api/finance/endTripIncomeBill";
import { getB2Bbill } from "@/api/finance/b2b_details";
import { getAllClient } from "@/api/user/client";
import { getKeysType, getSelectType } from "@/api/public";
import cTable from "@/base/common/index";
import Details from "./details";
import { getUser } from "@/api/user/internal";
import { getBank } from "@/api/finance/bank";
import { getService } from "@/api/double/list";
import { getCurrency } from "@/api/finance/currency";
import AmountExpand from "./amountExpand";
export default {
  name: "endTripIncomeBill",
  components: {
    cTable,
    Details,
		AmountExpand
  },
	activated() {
		if(this.$store.state.user.pageUrl){
		this.config.isGetList = true;
	  this.$refs["table"].$refs[
	    "header"
	  ].searchForm.keywords = this.$store.state.user.pageUrl;
	  this.$store.state.user.pageUrl = "";
		this.$nextTick(()=>{
			this.$refs["table"].getList();
		})
		}
	},
	mounted() {
		if(!this.$store.state.user.pageUrl){
			this.$refs["table"].getList();
		}
	},
  data() {
    return {
			config:{
				isGetList:true
			},
      methods: {
        list: getB2bBill,
        getB2bBillUSer,
        addB2bBill,
        updateB2bBill,
        ConfirmB2bBill,
        getDetails,
        b2bReStatistics,
        b2bWriteOff,
        getConfig,
        delDouBill,
        getB2bBillDetails,
        getB2bContractHeader,
        againBillAmount,
        getKeysType,
        getBank,
        postConfirm,
        getCurrency,
				append,
				removeDetail1,
				recalculate,
				getWaitWriteOff,
				getWriteOffRecord,
				cancelConfirm
      },
      modals: {
        /* add: {
          methods: {
            ok({ row, close }) {
              this.$page.handleRequestMethods("addB2bBill", row).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              client_ids: [
                {
                  required: true,
                  type: "number",
                  message: this.$t("select") + this.$t("clientName"),
                  trigger: "change",
                },
              ],
              name: [
                {
                  required: true,
                  message: this.$t("enter") + this.$t("codNAme"),
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ client_ids: 24 }, { name: 24 }],
          fields: [
            {
              name: () => this.$t("clientName"),
              key: "client_ids",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("order_number"),
              options: [],
              config: { label: "account", value: "id" },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getB2bBillUSer")
                  ).payload;
                  this.$forceUpdate();
                },
              },
            },
            {
              name: () => this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme"),
            },
          ],
        }, */
        update: {
					type:'add',
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("updateB2bBill", row)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 800,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "Please Enter name",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ currency: 8, to_rate:8, usd_to_tate:8 }, { bill_name: 24 }, { remarks: 24 }],
          fields: [
						{
						  name: this.$t("to")+ this.$t("toCurrency"),
						  key: "currency",
						  component: "Select",
						  placeholder: () => this.$t("select") + this.$t("to")+ this.$t("toCurrency"),
						  options: [],
						  config: {
						    label: "title",
						    value: "code",
						  },
						  methods: {
						    list({ field }) {
						      getCurrency().then((res) => {
						        if (res.data.status) {
						          field.options = res.data.payload.rows;
						        }
						      });
						    },
						  },
						},
						{
						  name: () => this.$t("to")+ this.$t('rate'),
						  key: "to_rate",
						  component: "InputNumber",
							bind:{
								style:'width:100%'
							},
						  placeholder: () => this.$t("enter") + this.$t("to")+ this.$t('rate'),
						},
						{
						  name: () => this.$t("to_usd")+this.$t("to")+ this.$t('rate'),
						  key: "usd_to_tate",
						  component: "InputNumber",
							bind:{
								style:'width:100%'
							},
						  placeholder: () => this.$t("enter") + this.$t("to_usd")+this.$t("to")+ this.$t('rate'),
						},
            {
              name: () => this.$t("codNAme"),
              key: "bill_name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme"),
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                rows: 5,
                type: "textarea",
              },
            },
          ],
        },
        writeOff: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = row;
              delete data.bill_order;
              data.ids = this.selectAll.map(
                (item) => item.id
              );
              this.$page
                .handleRequestMethods("b2bWriteOff", data)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
            checkTable({ row }) {
							console.log(arguments,this);
							let amount = 0
							row.forEach(t=>{
								amount += parseFloat(t.un_check_amount)
							})
							Object.assign(this.$refs["form"].formData, {check_amount:amount});
              this.$forceUpdate();
            },
          },
          config: {
            modalBind: {
              width: 1000,
              draggable: true,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              contract_header: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number",
                },
              ],
              check_amount: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              bank_name: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
						{ check_amount: 12 ,check_amount_currency: 12 },
						{ bank_name: 12, pay_time: 12 },
						{ transaction_id: 24 },
						{remarks:24},
            // { search_cnbnum: 24 }
          ],
          fields: [
						{
						  name: () => this.$t("Remarks"),
						  key: "remarks",
						  component: "Input",
						  placeholder: () => this.$t("enter") + this.$t("Remarks"),
						  bind: {
						    rows: 5,
						    type: "textarea",
						  },
						},
            {
              name: () => this.$t("bank"),
              key: "bank_name",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("bank"),
              options: [],
              config: {
                label:'value',
                value: "value",
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getBank")
                  ).payload.map(t=>{
										t.value = t.account_type + "(" + t.bank_code + ")"
										return t
									});
                  this.$forceUpdate();
                },
              },
            },
            {
              name: () => this.$t("paid_time"),
              key: "pay_time",
              component: "DatePicker",
              placeholder: () => this.$t("select") + this.$t("paid_time"),
              bind: {
                type: "datetime",
                format: "yyyy-MM-dd HH:mm:ss",
              },
            },
            {
              name: () => this.$t("check_amount"),
              key: "check_amount",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.0001,
                style: "width:100%",
              },
              default: 0,
            },
            {
              name: () => this.$t("check_amount_currency"),
              key: "check_amount_currency",
              component: "Input",
							disabled:true,
              placeholder: () =>
                this.$t("select") + this.$t("check_amount_currency"),
            },
            {
              name: () => this.$t("transaction_id"),
              key: "transaction_id",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("transaction_id"),
            },
          ],
          table: {
            config: {
              height: 300,
            },
            fields: [
							 {
								 type: "checkbox",
								 width: 60,
								 fixed: "left",
							 },
              {
                name: () => this.$t("currency_t"),
                key: "to_currency",
                minWidth: 130,
              },
              {
                name: () => this.$t("check_amount"),
                key: "check_amount",
                minWidth: 130,
              },
              {
                name: () => this.$t("arrears"),
                key: "un_check_amount",
                minWidth: 130,
              },
            ],
          },
        },
				writeOffList:{
					type: "add",
					footer:{
						show:()=>false
					},
					config: {
						modalBind: {
							width: 900,
							draggable: true,
						},
					},
					table: {
						config: {
							height: 700,
						},
						fields: [
							{
								name: () => this.$t("check_amount"),
								key: "check_amount",
								minWidth: 100,
							},
							{
								name: () => this.$t("transactionNumber"),
								key: "transaction_id",
								minWidth: 100,
							},
							{
								name: () => this.$t("writeOffUser"),
								key: "create_name",
								minWidth: 100,
							},
							{
								name: () => this.$t("check_remarks"),
								key: "remarks",
								minWidth: 100,
							},
							{
								name: () => this.$t("paid_time"),
								key: "pay_time",
								minWidth: 140,
							},
							{
								name: () => this.$t("bank_name"),
								key: "bank_name",
								minWidth: 140,
							},
							{
								name: () => this.$t("check_time"),
								key: "create_time",
								minWidth: 140,
							},
						],
					},
				},
        rate: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("againBillAmount", row)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              to_currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [
            { to_currency: 24 },
            { cny_rate: 24 },
            { usd_rate: 24 },
            { hkd_rate: 24 },
            { sar_rate: 24 },
          ],
          fields: [
            {
              name: this.$t("toCurrency"),
              key: "to_currency",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("toCurrency"),
              options: [],
              config: {
                label: "title",
                value: "code",
              },
              methods: {
                list({ field }) {
                  getCurrency().then((res) => {
                    if (res.data.status) {
                      field.options = res.data.payload.rows;
                    }
                  });
                },
              },
            },
            {
              name: () => this.$t("to_rmb") + this.$t("to") + this.$t("rate"),
              key: "cny_rate",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.0001,
                style: "width:100%",
              },
              default: 0,
            },
            {
              name: () => this.$t("to_usd") + this.$t("to") + this.$t("rate"),
              key: "usd_rate",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.0001,
                style: "width:100%",
              },
              default: 0,
            },
            {
              name: () => this.$t("to_hkd") + this.$t("to") + this.$t("rate"),
              key: "hkd_rate",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.0001,
                style: "width:100%",
              },
              default: 0,
            },
            {
              name: () => this.$t("to_sar") + this.$t("to") + this.$t("rate"),
              key: "sar_rate",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.0001,
                style: "width:100%",
              },
              default: 0,
            },
          ],
        },
        showDetails: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 1500,
            },
            modalContentBind: {
              style: {
                height: "700px",
              },
            },
          },
          footer: { show: () => false },
        },
				add:{
          methods: {
            ok({ row, close }) {
							row.type = 1
              this.$page
                .handleRequestMethods("append", row)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              extract: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [
            { extract: 24 },
          ],
          fields: [
            {
              name: () => this.$t("mawb"),
              key: "extract",
              component: "Input",
              bind: {
                type: "textarea",
								autosize:{minRows: 5,maxRows: 5}
              },
              placeholder: () => this.$t("enter") + this.$t("mawb"),
            },
          ],
        },
      },
      footer: { show: () => true },
      header: {
        searchs: [
          {
            key: "time_type",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            component: "Select",
            options: [],
          },
          {
            key: "startTime",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
            methods: {
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm.endTime = time;
                }
              },
            },
          },

          {
            key: "client_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            options: [],
            config: { label: "account", value: "id" },
          },
          {
            key: "sale_id",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            component: "Select",
            options: [],
            config: {
              label({ row }) {
                return row.realname
                  ? row.account + "(" + row.realname + ")"
                  : row.account;
              },
              value: "id",
            },
          },
          {
            key: "status",
            placeholder() {
              return this.$t("select") + this.$t("status");
            },
            component: "Select",
            options: [],
          },
          {
            key: "keywordsType",
            placeholder() {
              return this.$t("select") + this.$t("keyword") + this.$t("type");
            },
            component: "Select",
            config: {
              label({ row }) {
                return this.$t(row.label);
              },
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = await this.$sel.getData("INCOME_BILL_KEYWORDS");
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 1, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning",
              },
              id: 389,
            },
            // {
            //   name: () => this.$t("pushClinet"),
            //   type: "pushClinet",
            //   fnName: "pushClinet",
            //   disabled() {
            //     return !this.selectAll.length;
            //   },
            //   bind: {
            //     icon: "md-checkmark",
            //     type: "error"
            //   }
            // },
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
              id: 596,
            },
						// {
						//   name: this.$t("resAmount"),
						//   type: "resAmount",
						//   fnName: "resAmount",
						//   bind: {
						//     type: "primary",
						//   },
						// },
						{
						  name: this.$t("cancel") + this.$t("confirm"),
						  type: "cancel",
						  fnName: "cancel",
						  bind: {
						    type: "primary",
						  },
							disabled() {
							  return !this.selectAll.length;
							},
						},
          ],
          methods: {
						cancel(){
							this.$Modal.confirm({
							  title: this.$t("cancel") + this.$t("confirm"),
							  width: 300,
							  content: this.$t("titleModal"),
							  onOk: () => {
							    this.handleRequestMethods("cancelConfirm",{ids:this.selectAll.map(t=>t.id)}).then(
							      res => {
							        this.$Message["success"]({
							          background: true,
							          content: res.msg
							        });
							        this.getList()
							      }
							    );
							  }
							});
						},
						resAmount({ row }) {
						  this.$Modal.confirm({
						    title: this.$t("resAmount"),
						    width: 300,
						    content: this.$t("titleModal"),
						    onOk: () => {
						      this.handleRequestMethods("recalculate").then(
						        res => {
						          this.$Message["success"]({
						            background: true,
						            content: res.msg
						          });
						          this.getList()
						        }
						      );
						    }
						  });
						},
            // 导出
            export() {
              this.exportExc();
            },
            // 新增
            add() {
              this.getModal("add").setTitle(this.$t("add"));
              this.getModal("add").type = "add";
              this.getModal("add").open();
            },
            // 推送
            pushClinet() {
              let data = this.selectAll.map((item) => item.id);
              this.$Modal.confirm({
                title: this.$t("confirm") + this.$t("pushClinet"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("ConfirmB2bBill", {
                    ids: data,
                  }).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("bill_number"),
          key: "bill_number",
          component: this.$hasPermission(1121) || true ? "Button" : "span",
          minWidth: 200,
          fixed: "left",
          copy: true,
          bind: {
            type: "primary",
            size: "small",
          },
          methods: {
            render({ row }) {
              return row.bill_number;
            },
            click({ row }) {
              if (!this.$hasPermission(1121) && false) return;
              this.$page.getModal("showDetails").open(row, function () {
                this.setTitle(row.bill_number);
              });
            },
          },
        },
        {
          name: () => this.$t("clientName"),
          key: "account",
          minWidth: 100,
          align: "left",
        },
        {
          name: () => this.$t("salesman"),
          align: "left",
          key: "sale_name",
          width: 170,
        },
        {
          name: () => this.$t("preferential"),
          minWidth: 100,
          key: "main_contract_header",
        },
        {
          name: () => this.$t("shipper_company_cn"),
          key: "shipper_company_cn",
          width: 170,
        },
        {
          name: () => this.$t("mawb"),
          key: "extract",
          width: 170,
        },
        {
          name: () => this.$t("bill1"),
          children: [
            {
              name: () => this.$t("invoiceName"),
              align: "left",
              key: "bill_name",
              width: 120,
            },
            {
              name: () => this.$t("Remarks"),
              align: "left",
              key: "remarks",
              width: 120,
            },
            {
              name: () => this.$t("currency_t"),
              align: "left",
              key: "currency",
              width: 120,
            },
            {
              name: () => this.$t("reChAmount"),
              align: "left",
              key: "amount",
              width: 120,
            },
          ],
        },
        {
          name: () => this.$t('to')+this.$t("rate"),
          align: "left",
          key: "to_rate",
          width: 120,
        },
				{
				  name: () => this.$t('USD') + this.$t('to')+this.$t("rate"),
				  align: "left",
				  key: "usd_to_rate",
				  width: 120,
				},
        {
          name: () => this.$t("exlType"),
          key: "status_txt",
          align: "left",
          minWidth: 120,
        },
        {
          name: () => this.$t("createTime"),
          align: "left",
          key: "create_time",
          width: 170,
        },
        {
          name: () => this.$t("createUser"),
          align: "left",
          key: "create_name",
          width: 170,
        },
        {
          name: () => this.$t("writeOff") + this.$t("information"),
          children: [
            {
              name: () => this.$t("check_amount"),
              key: "check_amount",
              align: "left",
              minWidth: 120,
            },
            {
              name: () => this.$t("writeOffUser"),
              key: "check_name",
              minWidth: 100,
            },
            {
              name: () => this.$t("check_time"),
              align: "left",
              key: "check_time",
              width: 170,
            },
          ],
        },
        {
          name: () => this.$t("comfirmUser"),
          align: "left",
          key: "confirm_name",
          width: 170,
        },
        {
          name: () => this.$t("confirm_time"),
          align: "left",
          key: "confirm_time",
          width: 170,
        },
        {
          name: this.$t("operation"),
          type: "btns",
          width: 300,
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("addTo"),
              type: "add",
              fnName: "add",
              bind: {
                type: "primary"
              },
							disabled({ row }) {
							  return row.status != 1 ;
							},
              // disabled({ row }) {
              //   console.log(row);
              // }
            },
            // {
            //   name: this.$t("rate"),
            //   type: "rate",
            //   fnName: "rate",
            //   bind: {
            //     type: "warning",
            //   },
            //   disabled({ row }) {
            //     return row.status == 4 || row.status == 8 || row.status == 9;
            //   },
            //   id: 594,
            // },
            {
              name: this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success",
              },
              // id: 1122,
            },
            {
              name: () => this.$t("confirmOrder"),
              type: "confirmOrder",
              fnName: "confirmOrder",
              bind: {
                type: "error",
              },
              disabled({ row }) {
                return row.status != 1;
              },
              // id: 1124,
            },
						{
							name: this.$t("cancel") + this.$t("confirm"),
							type: "cancel",
							fnName: "cancel",
							bind: {
								type: "primary",
							},
							disabled({row}) {
								return row.status < 4;
							},
						},
            {
              name: this.$t("writeOff"),
              type: "writeOff",
              fnName: "writeOff",
              bind: {
                type: "primary",
              },
              disabled({ row }) {
                return row.status < 4 ;
              },
              // id: 1125,
            },
						{
						  name: this.$t("writeOff")+this.$t('record'),
						  type: "writeOffList",
						  fnName: "writeOffList",
						  bind: {
						    type: "primary",
						  },
							disabled({ row }) {
							  return row.status <= 4 ;
							},
						},
            /* {
              name: () => this.$t("rate"),
              align: "center",
              width: 100,
              fnName: "rate",
              id: 1126,
              bind: {
                type: "error",
                size: "small",
              },
              disabled({ row }) {
                return row.status == 9;
              },
              methods: {
                render() {
                  return this.$t("rate");
                },
              },
            }, */
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              // id: 1123,
              disabled({ row }) {
                return row.status != 1;
              },
            },
						
          ],
          methods: {
						cancel({row}){
							this.$Modal.confirm({
								title: this.$t("cancel") + this.$t("confirm"),
								width: 300,
								content: this.$t("titleModal"),
								onOk: () => {
									this.handleRequestMethods("postConfirm",{id:row.id,type:2}).then(
										res => {
											this.$Message["success"]({
												background: true,
												content: res.msg
											});
											this.getList()
										}
									);
								}
							});
						},
            add({ row }) {
              this.getModal("add").open({ id: row.id }, function() {
                this.setTitle(row.bill_number + "(" + this.$t("addTo") + ")");
              });
            },
            update({ row }) {
              let data = {
                remarks: row.remarks,
                bill_name: row.bill_name,
                id: row.id,
								currency:row.currency,
								to_rate:row.to_rate,
								usd_to_tate:row.usd_to_tate
              };
              this.getModal("update").open(data, function () {
                this.setTitle(row.bill_number + "(" + this.$t("update") + ")");
              });
            },
            writeOff({ row }) {
							this.handleRequestMethods('getWaitWriteOff',row.id).then(res=>{
								let data = {
									payment_bank:row.payment_bank,
									payment_time:row.payment_time,
									transaction_id:row.transaction_id,
									write_off_remarks:row.write_off_remarks,
									check_amount_currency: row.currency,
									id:row.id,
								}
								this.getModal("writeOff").open(data,function(){
									this.setTitle(this.$t("writeOff"))
									this.list = res.payload
									if(res.payload.length === 1){
										this.$nextTick(()=>{
											this.$refs.table.$refs.xTable.setRadioRow(this.list[0])
										})
									}
								});
							})
            },
						writeOffList({ row }) {
							this.handleRequestMethods('getWriteOffRecord',row.id).then(res=>{
								this.getModal("writeOffList").open({},function(){
									this.setTitle(this.$t("writeOff")+this.$t('record'))
									this.list = res.payload
								});
							})
						},
            rate({ row }) {
              this.getModal("rate").open(row, function () {
                this.setTitle(row.bill_number + "(" + this.$t("rate") + ")");
              });
            },
            recalculate({ row }) {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("resAmount"),
                width: 300,
                content: this.$t("bill1") + "(" + row.bill_number + ")",
                onOk: () => {
                  this.handleRequestMethods("againBillAmount", {
                    id: row.id,
                  }).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
            confirmOrder({ row }) {
              console.log(row);
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("confirmOrder"),
                width: 300,
                content: this.$t("bill1") + "(" + row.bill_number + ")",
                onOk: () => {
                  this.handleRequestMethods("postConfirm", {id:row.id,type:1}).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("delete"),
                width: 300,
                content: this.$t("bill1") + "(" + row.bill_number + ")",
                onOk: () => {
                  this.handleRequestMethods("delDouBill", row.id).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
          },
        },
      ],
    };
  },
  async created() {
    let client = (await getAllClient()).data.payload.rows;
    let salesman = (await getUser({ standard: "Salesman" })).data.payload.rows;
    this.header.searchs.forEach(async (item) => {
      if (item.key === "time_type") {
        item.options = (await getSelectType(["BILL_TIME_TYPE"])).data.payload[
          "BILL_TIME_TYPE"
        ];
        this.$refs["table"].$refs["header"].searchForm["time_type"] =
          item.options[0].key;
      }
      if (item.key === "status")
        item.options = (await getSelectType(["BILL_STATUS_TYPE"])).data.payload[
          "BILL_STATUS_TYPE"
        ];
      if (item.key === "client_id") item.options = client;
      if (item.key === "sale_id") item.options = salesman;
    });
  },
};
</script>
